export default "__VITE_ASSET__Cty2nRWS__"